import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

import { useGetProject } from '../../common/useGetProject';
import { BreadcrumbItem, Breadcrumbs } from '../../components/Breadcrumbs';
import { pathToUrl } from '../../utils/router';
import { PageRoutesEnum } from '../../utils/routes';
import { CandidateType } from '../candidates/Candidates.types';
import { RecruitmentHistoryType } from '../recruitments/Recruitments.types';

const MainContainer = styled.div`
  margin-bottom: 20px;
`;

const TitleContainer = styled.div`
  & h3 {
    display: inline;
  }
`;

type RecruitmentDetailsHeaderProps = {
  candidate: CandidateType;
  recruitment: RecruitmentHistoryType;
};

export const DetailsHeader: React.ForwardRefRenderFunction<HTMLDivElement, RecruitmentDetailsHeaderProps> = (
  { candidate, recruitment },
  ref
) => {
  const { data: project } = useGetProject(recruitment.projectUuid);

  const breadcrumbItems = [
    {
      title: <BreadcrumbItem path={PageRoutesEnum.recruitments} title="Recruitments" />,
    },
    {
      title: (
        <TitleContainer ref={ref}>
          <BreadcrumbItem
            path={pathToUrl(PageRoutesEnum.candidateEdit, { id: candidate.uuid })}
            title={`${candidate.firstName} ${candidate.lastName}`}
          />
          {project?.uuid && (
            <>
              <Typography.Title level={3}> to </Typography.Title>
              <BreadcrumbItem
                path={pathToUrl(PageRoutesEnum.projectsEdit, { id: project.uuid })}
                title={project?.name}
              />
            </>
          )}
        </TitleContainer>
      ),
    },
  ];

  return (
    <MainContainer>
      <Breadcrumbs breadcrumbItems={breadcrumbItems} />
    </MainContainer>
  );
};

export const RecruitmentDetailsHeader = React.forwardRef<HTMLDivElement, RecruitmentDetailsHeaderProps>(DetailsHeader);
